module.exports = __webpack_public_path__ + "static/media/frames-company-logos.24eb06d1.jpg";